module.exports = __webpack_public_path__ + "images/category_lp/fishing_gear/store_images/5_bf14dc606c16fd31a0c5d690546fa14b.png";